import React, { Component } from "react";
import { Group } from "../../utils/logger";

import { Button } from "reactstrap";
import MicrosoftLogo from "./MicrosoftLogo.png";

// State management
import PropTypes from "prop-types";
import { connect } from "react-redux";

export class SamlSSO extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: {},
    };

    this.LoggerGroup = new Group("SAML SSO", { disable: true });
    this.LoggerGroup.emit("Loaded");
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    event.preventDefault();
    window.location.hostname.includes("localhost")
      ? window.location.replace("http://localhost:8000/api/v1/auth/login/saml")
      : window.location.replace("/api/v1/auth/login/saml");
  }

  render() {
    return (
      <React.Fragment>
        <Button variant="outline-secondary" onClick={this.handleChange}>
          <img
            src={MicrosoftLogo}
            alt="Microsoft Logo"
            className="mr-2"
            style={{ height: "20px" }}
          />
          Sign in with Microsoft
        </Button>
      </React.Fragment>
    );
  }
}

SamlSSO.propTypes = {
  loading: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.user.loading,
  errors: state.user.errors,
});

export default connect(mapStateToProps, {})(SamlSSO);
